export default __webpack_public_path__ + "static/heroCovidOnlyDesktop-d29b9ac073af20603fc9e919d12b38b2.png";